const LOGIN = "api/common/v2/login/";
const ACCOUNT_LOGIN = "api/common/v2/account-login/";
const USER = "api/common/v2/user/";
const USERList = "api/common/v2/user/";
const ACCOUNTList = "api/common/v2/account/";
const ACCOUNT_LIST_V1 = "api/common/v1/account/";
const ACCOUNT_LIST_V2 = "api/common/v2/account/";
const JOB_FAMILY = "job-family/";
const JOB_SCORING_CONFIG = "job-scoring-config/";
const RESPONSIBILITY = "api/proficiency/v2/account/";
const RESPONSIBILITY_V2 = "api/proficiency/v2/account/";
const RESPONSIBILITY_TO_POSITION = "responsibility-to-position/";
const TASKS = "api/proficiency/v2/account/";
const CURRENCY = "api/common/v2/currencies/";
const PROFICIENCY_V1 = "api/proficiency/v2/account/";
const PROFICIENCY_V2 = "api/proficiency/v2/account/";
const COMMON_V1 = "api/common/v2/";
const COMMON_V2 = "api/common/v2/";
const ASK_IQ = "ask";
const SUGGEST_QUIZ = "suggest-quiz/";
const SUGGEST_INSPECTION_PROTOCOL = "suggest-inspection-protocol/";
const INSPECTION_REQUESTS_AS_COACH_HISTORY = "inspection-requests/as-coach/history/";
const SUGGEST_CONTEXT_ROLE_NAME = "suggest_context_role_name/";
const SUGGEST_CONTEXT_RESPONSIBILITY_NAME = "suggest_context_responsibility_name/";
const SUGGEST_CONTEXT_RESPONSIBILITY = "suggest_context_responsibility/";
const SUGGEST_CONTEXT_ROLE = "suggest_context_role/";
const SUGGEST_CONTEXT_POSITION = "suggest_context_position/";
const SUGGEST_CONTEXT_DEPARTMENT = "suggest_context_department/";
const SUGGEST_CONTEXT = "api/iq/suggest-context/";
const SUGGEST_CONTEXT_ACCOUNT_FROM_URLS = "api/iq/suggest-context/account-from-urls/";
const GET_SUGGESTIONS = "get_suggestions/";
const POSITION_IMPORT_EXTRACT = "extract-position-responsibilities/";
const APP_CONFIG = "api/v2/app-config";
const IMPERSONATE_END = "api/common/v2/admin/impersonate/end/";
const IMPERSONATE_EXCHANGE = "api/common/v2/admin/impersonate/exchange/";
const VIEW_AS_START = "api/common/v2/admin/view-as/start/";
const VIEW_AS_EXCHANGE = "api/common/v2/admin/view-as/exchange/";
const VIEW_AS_STOP = "api/common/v2/admin/view-as/stop/";
const PREVIEW_START = "api/common/v2/admin/preview/start/";
const PREVIEW_EXCHANGE = "api/common/v2/admin/preview/exchange/";
const PREVIEW_STOP = "api/common/v2/admin/preview/stop/";
const CONTEXT_FILES = "api/common/v2/context-files/";
const MARKET_DATA_FILES = "api/common/v2/accounts/";
const ACCOUNT_ACTIVITY_FEED = "api/common/v2/accounts/";
const ACCOUNT_CHATTER_FEED = "api/common/v2/accounts/";
const ACCOUNT_FOLLOWS = "api/common/v2/account/";
const POSITIONS_WITH_PAY_RANGE_SUBSCRIPTIONS = "positions-with-pay-range-subscriptions/";
const POSITION_READINESS = "position/readiness/";
const PAY_RANGE_SUBSCRIPTION = "pay-range-subscription/";
const PAY_RANGE_SUBSCRIPTION_SUBSCRIBE = "pay-range-subscription/subscribe/";
const PAY_RANGE_SUBSCRIPTION_END = "end/";
const EMPLOYEE_PAY_PLANS_LIST = "pay-plans-list/";
const EMPLOYEE_FAIR_PAY_LIST = "fair-pay-list/";
const EMPLOYEE_COMMIT_PAY_PLAN = "commit-pay-plan/";
const EMPLOYEE_PAY_PLAN_DRAFT = "pay-plan-draft/";
const EMPLOYEE_PAY_PLAN_SUMMARY = "pay-plan-summary/";
const PAY_PLAN_PROPOSALS = "pay-plan-proposals/";
const PAY_PLAN_VERSIONS = "pay-plan-versions/";
const PAY_PLAN_CONTEXT = "pay-plan-context/";
const SCRIBE_IMPORT = "scribe-import/";
const PDF_IMPORT = "pdf-import/";
const WORD_IMPORT = "word-import/";
const NAME_AVAILABILITY = "name-availability/";
const PERFORMANCE_V2 = "api/performance/v2/";
const ORGANIZATION_HEALTH = "organization-health/";
const EMPLOYEES_MENTIONABLE = "employee/mentionable/";
const INTEGRATIONS_STATUS = "integrations/status/";
const COMPANY_WEBSITES_SCAN_NOW = "company-websites/scan-now/";

export const API = {
  LOGIN,
  ACCOUNT_LOGIN,
  USER,
  USERList,
  ACCOUNTList,
  ACCOUNT_LIST_V1,
  ACCOUNT_LIST_V2,
  JOB_FAMILY,
  JOB_SCORING_CONFIG,
  RESPONSIBILITY,
  RESPONSIBILITY_V2,
  RESPONSIBILITY_TO_POSITION,
  TASKS,
  CURRENCY,
  PROFICIENCY_V1,
  PROFICIENCY_V2,
  COMMON_V1,
  COMMON_V2,
  ASK_IQ,
  SUGGEST_QUIZ,
  SUGGEST_INSPECTION_PROTOCOL,
  INSPECTION_REQUESTS_AS_COACH_HISTORY,
  SUGGEST_CONTEXT_ROLE_NAME,
  SUGGEST_CONTEXT_RESPONSIBILITY_NAME,
  SUGGEST_CONTEXT_RESPONSIBILITY,
  SUGGEST_CONTEXT_ROLE,
  SUGGEST_CONTEXT_POSITION,
  SUGGEST_CONTEXT_DEPARTMENT,
  SUGGEST_CONTEXT,
  SUGGEST_CONTEXT_ACCOUNT_FROM_URLS,
  GET_SUGGESTIONS,
  POSITION_IMPORT_EXTRACT,
  APP_CONFIG,
  IMPERSONATE_END,
  IMPERSONATE_EXCHANGE,
  VIEW_AS_START,
  VIEW_AS_EXCHANGE,
  VIEW_AS_STOP,
  PREVIEW_START,
  PREVIEW_EXCHANGE,
  PREVIEW_STOP,
  CONTEXT_FILES,
  MARKET_DATA_FILES,
  ACCOUNT_ACTIVITY_FEED,
  ACCOUNT_CHATTER_FEED,
  ACCOUNT_FOLLOWS,
  POSITIONS_WITH_PAY_RANGE_SUBSCRIPTIONS,
  POSITION_READINESS,
  PAY_RANGE_SUBSCRIPTION,
  PAY_RANGE_SUBSCRIPTION_SUBSCRIBE,
  PAY_RANGE_SUBSCRIPTION_END,
  EMPLOYEE_PAY_PLANS_LIST,
  EMPLOYEE_FAIR_PAY_LIST,
  EMPLOYEE_COMMIT_PAY_PLAN,
  EMPLOYEE_PAY_PLAN_DRAFT,
  EMPLOYEE_PAY_PLAN_SUMMARY,
  PAY_PLAN_PROPOSALS,
  PAY_PLAN_VERSIONS,
  PAY_PLAN_CONTEXT,
  SCRIBE_IMPORT,
  PDF_IMPORT,
  WORD_IMPORT,
  NAME_AVAILABILITY,
  PERFORMANCE_V2,
  ORGANIZATION_HEALTH,
  EMPLOYEES_MENTIONABLE,
  INTEGRATIONS_STATUS,
  COMPANY_WEBSITES_SCAN_NOW,
};
